<template>
   <b-card no-body :id="'widgetppt' + widget.id">
     <div class="card-header" :class="{fixedCardHeader: isOverflown}">
        <span v-b-tooltip.hover :title="title" class="widget-title">{{title}}</span>
        <settings-button />
      </div>
      <b-card-body class="p-3 clearfix" @click="handleClickThrough" style="position: relative">
        <h5 class="loading-text" v-show="!goodChart">Unable To Load Data</h5>
        <FunnelChart ref=chart v-show="goodChart" :asPyramid= "widget.as_pyramid" :h="widgetData().h" :w="widgetData().w"/>
      </b-card-body>
    <div class="comparison-disclaimer" v-if="this.widget.disableDataComparison"><sup>*</sup>Data comparison unavailable</div>
   </b-card>
</template>
<script>
import FunnelChart from '@/views/charts/FunnelChart'
import {base_widget} from '@/views/widgets/base_widget'
export default {
  name: 'FunnelWidget',
  mixins: [base_widget],
  components: {
    FunnelChart
  },
  data () {
    return {
      borderColor: ['transparent'],
      goodChart: true
    }
  },

  mounted () {
    this.changeChartId()
  },

  computed: {
    colors() {
      return this.colorsArray
    }
  },

  methods: {
    setData (response) {
      var chart = this.$refs.chart
      if (!chart) { return false }
      var data = response.data.data
      let labels = this.setLabels(data)
      let datasets = this.setDatasets(data)
      if (labels.length > 0) {
        chart.labels = labels
        chart.datasets = datasets
        chart.disableLegend = this.widget.disableLegend
        let funnel_order = this.widget.funnel_order ? 'asc' : 'desc'
        chart.createChart(funnel_order)
        this.saveWidgetData(datasets.map( (set) => set.data), labels)
      } else {
        this.saveWidgetData({}, [])
        this.goodChart = false
      }
    },

    changeChartId () {
      var item = document.getElementById('funnel-chart')
      item.id = 'funnel-chart-' + this.widget.id
    }

  }
}

</script>
